<script setup lang="ts">
import { faCheck, faXmark } from '@fortawesome/pro-regular-svg-icons';
import CardDescriptionView from '@components/util/CardDescriptionView.vue';
import type TripPackage from '@itinerary/trip/TripPackage';
import SegmentInfo from '@components/ui/hotelPage&reserve&view/segment/SegmentInfo.vue';

const { tripPackage } = defineProps<{
    tripPackage: TripPackage;
}>();
onMounted(() => {
    if (tripPackage.isFlightPackage()) {
        tripPackage.defaultPrice?.loadBaggage();
    }
});
</script>

<template>
    <div id="package-info" class="package-info-container">
        <SegmentInfo
            v-for="(segment, key) in tripPackage.segments"
            :key
            :segment
            :price-class="tripPackage.defaultPrice ?? undefined"
            :toggleable="tripPackage.segments.length > 1"
        />
        <template v-if="tripPackage.packageInfoDescription">
            <CardDescriptionView
                v-for="info in tripPackage.packageInfoDescription"
                :key="info.title"
                :info
            />
        </template>
        <div v-if="tripPackage.facilities" class="facilities-container">
            امکانات {{ tripPackage.facilities.title }} :
            <div
                v-for="fac in tripPackage.facilities.list"
                :key="fac.title"
                class="facility-container"
            >
                <mr-icon
                    size="small"
                    :icon="fac.check ? faCheck : faXmark"
                    :color="fac.check ? 'var(--green-500)' : 'var(--red-400)'"
                />
                <div class="title">
                    {{ fac.title }}
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.package-info-container {
    display: flex;
    flex-direction: column;
    padding: 20px;
}

.operating-warning {
    display: flex;
    background: usePalette($p-blue, $p-100);
    padding: 4px;
    border-radius: 8px;
    .description {
        @include tg-s($w5, usePalette($p-blue));
        margin-right: 4px;
    }
}

.extra-details {
    @include tg-m($w5);
    margin-top: 16px;
}

.facilities-container {
    @include tg-m($w5);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .facility-container {
        display: flex;
        align-items: center;
        margin-right: 8px;
        .title {
            margin-right: 4px;
        }
    }
}
</style>
